import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { ReadWriteRecipientWellSize } from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';

export const getPersonaSizeFromRecipientWellSize = (size: ReadWriteRecipientWellSize) => {
    switch (size) {
        case ReadWriteRecipientWellSize.Small:
            return PersonaSize.size24;
        case ReadWriteRecipientWellSize.Regular:
            return PersonaSize.size32;
    }
};
